import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getOrderById, cancelOrder } from "../../../../api/orderService";
import { validateShipment } from "../../../../api/blockchainApi";

export default function LegalEntityOrderDetailsPage() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);
    const [validation, setValidation] = useState(null);
    const [checking, setChecking] = useState(false);

    useEffect(() => {
        if (!id) return;

        getOrderById(id)
            .then(setOrder)
            .finally(() => setLoading(false));
    }, [id]);

    const handleCancel = async () => {
        if (!window.confirm("Cancel this order?")) return;

        await cancelOrder(id);
        navigate("/legal/orders");
    };

    const handleValidate = async () => {
        if (!order?.shipmentId) {
            setValidation({ isValid: false, message: "Shipment ID is missing." });
            return;
        }

        setChecking(true);

        try {
            const res = await validateShipment(order.shipmentId);
            setValidation(res);
        } catch {
            setValidation({ isValid: false, message: "Validation failed." });
        } finally {
            setChecking(false);
        }
    };

    if (loading) return <p>Loading...</p>;
    if (!order) return <p>Order not found</p>;

    return (
        <div className="max-w-4xl mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-xl font-bold mb-4">
                Order #{order.orderNumber || order.id}
            </h2>

            <p><b>Amount:</b> {order.totalAmount} {order.currency}</p>
            <p><b>Status:</b> {order.shipment?.status || "Created"}</p>
            <p><b>Payment:</b> {order.paymentStatus || "Pending"}</p>

            <div className="mt-4 flex gap-3">
                <button
                    className="bg-gray-300 px-4 py-2 rounded"
                    onClick={() => navigate("/legal/orders")}
                >
                    Back
                </button>

                {order.paymentStatus !== "Completed" && order.shipmentId && (
                    <button
                        className="bg-indigo-600 text-white px-4 py-2 rounded"
                        onClick={() =>
                            navigate(`/payments/create/${order.shipmentId}?orderId=${order.id}`)
                        }
                    >
                        Pay
                    </button>
                )}

                <button
                    className="bg-red-600 text-white px-4 py-2 rounded"
                    onClick={handleCancel}
                >
                    Cancel
                </button>

                {order.shipmentId && (
                    <button
                        className="bg-green-600 text-white px-4 py-2 rounded"
                        onClick={handleValidate}
                        disabled={checking}
                    >
                        {checking ? "Checking..." : "🔗 Validate Blockchain"}
                    </button>
                )}
            </div>

            {validation && (
                <div className="mt-4 p-3 rounded bg-gray-100">
                    <b>Blockchain status:</b>{" "}
                    {validation.isValid ? (
                        <span className="text-green-600">✔ Valid</span>
                    ) : (
                        <span className="text-red-600">❌ Tampered / Invalid</span>
                    )}

                    {validation.message && (
                        <p className="text-sm text-gray-600 mt-1">
                            {validation.message}
                        </p>
                    )}
                </div>
            )}
        </div>
    );
}